export default __webpack_public_path__ + "static/media/1E1FFC8E-1151-448F-A8FD-E2FAEBB726B5.27e9a481.png";